export function ajax (url, data, withCredentials) {
  return new Promise((resolve, reject) => {
    const req = new XMLHttpRequest()
    req.onreadystatechange = function () {
      /* global XMLHttpRequest */
      if (this.readyState === XMLHttpRequest.DONE) {
        if (this.status === 200) {
          console.log(this.responseType)
          resolve(this.getResponseHeader('Content-Type').indexOf('json') !== -1 ? JSON.parse(this.responseText) : this.responseText)
        } else {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject(this)
        }
      }
    }

    if (withCredentials === true) {
      req.withCredentials = true
    }

    req.open(!data ? 'GET' : 'POST', url, true)
    req.send(typeof data === 'object' ? JSON.stringify(data) : data)
  })
}
